import { Box, Typography } from '@mui/material';
import { RichTextEditor } from '../Requests/RichText';
import LinkList from './LinkList';

// General client-level notes — independent of any one provider's notes. The
// place for "how this client onboarded", context that outlives a single
// integration, links that aren't specific to one provider either.

const NotesTab = ({ doc, onDocChange }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box>
            <Typography sx={{ fontSize: 11.5, color: 'text.secondary', mb: 0.75 }}>
                General notes for this client — not tied to any one provider.
            </Typography>
            <RichTextEditor value={doc.notesHtml || ''} onChange={(html) => onDocChange({ ...doc, notesHtml: html })} />
        </Box>
        <Box>
            <Typography sx={{ fontSize: 12, fontWeight: 700, color: 'text.secondary', mb: 0.5, letterSpacing: 0.3 }}>LINKS</Typography>
            <LinkList links={doc.links || []} addLabel="Add link" onChange={(links) => onDocChange({ ...doc, links })} />
        </Box>
    </Box>
);

export default NotesTab;
